import styled from "styled-components";
import {CustomButton} from "../CustomButton/CustomButton";

export const DownloadButton = styled(CustomButton)`
    background-color: ${props => (props.type === "primary" ? "green" : "white")};
    border-color: ${props => (props.type === "primary" ? "green" : "green")};
    color: ${props => (props.type === "primary" ? "white" : "green")};
    &:hover,
    &:focus {
        background-color: ${props => (props.type === "primary" ? "green" : "white")};
        border-color: ${props => (props.type === "primary" ? "green" : "green")};
        color: ${props => (props.type === "primary" ? "white" : "green")};
        opacity: 0.8;
    }
`;
